import { render } from "./WorkcenterList.vue?vue&type=template&id=696cfa30"
import script from "./WorkcenterList.vue?vue&type=script&lang=ts"
export * from "./WorkcenterList.vue?vue&type=script&lang=ts"
script.render = render

export default script